import { render } from "./Traditional.vue?vue&type=template&id=7b3edb6c&scoped=true"
import script from "./Traditional.vue?vue&type=script&lang=js"
export * from "./Traditional.vue?vue&type=script&lang=js"

import "./Traditional.vue?vue&type=style&index=0&id=7b3edb6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3edb6c"]])

export default __exports__